/* ----------------------------------------------
Import modules
---------------------------------------------- */

import SimpleSelectorController from 'simple-selector';

/* ----------------------------------------------
Document setup
---------------------------------------------- */

// New object to store all the SimpleSelectors
window.SimpleSelectors = {};

// Create a watcher to look for new selects
const SelectWatcher = new Watcher();

// Every time a new select is added to the page, create a new SimpleSelectorController
SelectWatcher.on('update', selects => {
  selects.forEach(select => {
    window.SimpleSelectors[select.id] = select.SimpleSelector = new SimpleSelectorController(select);
    if (select.multiple) {
      select.SimpleSelector.select.classList.add('selector--multiple');
    }
    select.SimpleSelector.on('change', () => {
      // Do a jQuery change event on the select so that other scripts can listen for it
      try {
        $(select).trigger('change');
      } catch (e) {/* do nothing */}
    });
  });
});

// Watch for new selects
SelectWatcher.watch('select');